import createApi from './api';

export default class NotificationsService {
  constructor() {
    this.api = createApi({
      baseUrl: 'notifications',
      headers: {
        'Content-Type': 'application/json'
      },
    });
  }

  async loadAll({ past_data } = {}) {
    if (past_data) {
      return this.api.get('list', { past_data });
    } else {
      return this.api.get('list');
    }
  }

  async markAsRead({ notification_id, notification_type }) {
    return this.api.post('read', { notification_id, notification_type });
  }
}
